module.exports = __webpack_public_path__ + "img/p01.08981098.jpg";